import { Box, Icon, type Colors } from '@factorialco/deprecated-design-system'

import ShiftDetails from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails'
import type { ShiftGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const resolveShiftColor = (event: ShiftGridEvent): Colors => {
  if (event.isBackup) return 'grey300'
  if (event.conflicts.length > 0) return 'radicalRed200'

  return event.shift.color ?? 'grey400'
}

const hasPendingSwapShifts = (event: ShiftGridEvent): boolean => {
  const currentSwapShifts = event.shift.swapShifts
  const requestedSwapShifts = event.shift.swapShiftsRequests

  return currentSwapShifts.pending.length > 0 || requestedSwapShifts.pending.length > 0
}

const ShiftCard: EventCardSpec<ShiftGridEvent> = {
  getAppearance: (event) => ({
    background:
      event.isDraft || hasPendingSwapShifts(event) || (event.isBackup && event.shift.preview)
        ? 'grey000White'
        : resolveShiftColor(event),
    opacity: event.shift.preview ? '0.5' : '0.9',
    border: {
      all: {
        width: 's2',
        style:
          hasPendingSwapShifts(event) || event.shift.preview || event.conflicts.length > 0
            ? 'dashed'
            : 'solid',
        color: resolveShiftColor(event)
      }
    }
  }),
  render: (event) => {
    const shift = event.shift
    const plannedBreaks = shift.plannedBreaks?.plannedBreaks ?? []

    return (
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexStart">
        <ShiftDetails
          shift={shift}
          date={shift.currentStartDate}
          plannedBreaks={plannedBreaks}
          preview={shift.preview}
        />
        {event.isBackup ? (
          <Box justifyContent="center" padding="s6">
            <Icon.Small icon="history" color="grey600" />
          </Box>
        ) : null}
      </Box>
    )
  }
}

export { ShiftCard }
